var _KIND_MAPPING;

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  max-width: 100%;\n  transition: opacity 0.15s ease-in-out;\n  opacity: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      width: ", "px;\n      height: ", "px;\n      padding: 0;\n      align-items: center;\n      justify-content: center;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      min-height: ", "px;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  max-width: 100%;\n  margin: 0;\n  padding: 0 ", "px;\n  display: ", ";\n  ", "\n  width: ", ";\n  align-items: center;\n  justify-content: ", ";\n  border-radius: ", ";\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  user-select: none;\n  text-decoration: none;\n  text-align: center;\n  &::-moz-focus-inner {\n    outline: none;\n    border-style: none;\n    padding: 0;\n  }\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n          box-shadow: inset 0 0 0 ", " ", "\n            ", ";\n          &:hover {\n            background-color: ", ";\n            box-shadow: inset 0 0 0 ", " ", "\n            ", ";\n          }\n          &:active {\n            background-color: ", ";\n            box-shadow: inset 0 0 0 ", " ", "\n            ", ";\n          }\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n        box-shadow: inset 0 0 0 ", " ", "\n          ", ";\n        &:focus {\n          ", ";\n        }\n        &:hover {\n          background-color: ", ";\n          box-shadow: inset 0 0 0 ", "\n            ", "\n            ", ";\n        }\n        &:active {\n          background-color: ", ";\n          box-shadow: inset 0 0 0 ", "\n            ", "\n            ", ";\n        }\n\n        ", ";\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          opacity: 0.5;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        background-color: transparent;\n        box-shadow: 0px 0px 0px 3px rgba(165, 211, 242, 0);\n        ", ";\n        * {\n          transition: color 0.15s ease-in-out;\n        }\n        &:focus {\n          ", ";\n        }\n        &:hover * {\n          color: ", ";\n        }\n        &:active * {\n          color: ", ";\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      &:hover {\n        cursor: not-allowed;\n      }\n      &:focus {\n        box-shadow: none;\n      }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Padding, Sizes, Types } from './constants';
import { Shadows, Shape, getFocusStyles } from '@doordash/design-language';
import styled, { css } from 'styled-components';
import { withDynamicTag } from '@doordash/utilities';
var PILL_BORDER_RADIUS = '1000px';

var getPadding = function getPadding(props) {
  return props.padding === Padding.Wide ? props.size : 0;
};

var getDisplay = function getDisplay(props) {
  return props.isInline ? 'inline-flex' : 'flex';
};

var getHeight = function getHeight(props) {
  switch (props.size) {
    case Sizes.Small:
      return 32;

    case Sizes.Large:
      return 48;

    case Sizes.XLarge:
      return 48;

    case Sizes.Medium:
    default:
      return 40;
  }
};

var getWidth = function getWidth(props) {
  if (props.shape === Shape.Circle) {
    return "".concat(getHeight(props), "px");
  }

  return props.isInline ? 'auto' : '100%';
};

var getJustifyContent = function getJustifyContent(props) {
  return props.isInline ? 'flex-start' : 'center';
};

var getShapeBorderRadius = function getShapeBorderRadius(props) {
  switch (props.shape) {
    case Shape.Pill:
      return PILL_BORDER_RADIUS;

    case Shape.Circle:
      return '100%';

    case Shape.Rectangle:
    default:
      return "".concat(props.themeBorderRadius, "px");
  }
};

var getBorderRadius = function getBorderRadius(props) {
  switch (props.kind) {
    case Types.Full:
      return 0;

    case Types.PrimaryPill:
    case Types.SecondaryPill:
    case Types.TertiaryPill:
      return PILL_BORDER_RADIUS;

    case Types.Plain:
    default:
      return getShapeBorderRadius(props);
  }
};

var getDisabledStyle = function getDisabledStyle(props) {
  if (props.disabled) {
    return css(_templateObject());
  }

  return null;
};

var KIND_MAPPING = (_KIND_MAPPING = {}, _defineProperty(_KIND_MAPPING, Types.Primary, 'Primary'), _defineProperty(_KIND_MAPPING, Types.PrimaryPill, 'Primary'), _defineProperty(_KIND_MAPPING, Types.Full, 'Primary'), _defineProperty(_KIND_MAPPING, Types.Secondary, 'Secondary'), _defineProperty(_KIND_MAPPING, Types.SecondaryPill, 'Secondary'), _defineProperty(_KIND_MAPPING, Types.Tertiary, 'Tertiary'), _defineProperty(_KIND_MAPPING, Types.TertiaryPill, 'Tertiary'), _KIND_MAPPING);

var getFilledColorSet = function getFilledColorSet(_ref) {
  var isToggleable = _ref.isToggleable,
      isToggled = _ref.isToggled,
      kind = _ref.kind,
      themeColors = _ref.themeColors;
  var type = KIND_MAPPING[kind];
  return {
    // eslint-disable-next-line no-nested-ternary
    default: !isToggleable ? themeColors["Button".concat(type, "Background")] : !isToggled ? themeColors["Button".concat(type, "ToggleBackgroundOff")] : themeColors["Button".concat(type, "ToggleBackground")],
    // eslint-disable-next-line no-nested-ternary
    hovered: !isToggleable ? themeColors["Button".concat(type, "BackgroundHovered")] : !isToggled ? themeColors["Button".concat(type, "ToggleBackgroundOffHovered")] : themeColors["Button".concat(type, "ToggleBackgroundHovered")],
    // eslint-disable-next-line no-nested-ternary
    pressed: !isToggleable ? themeColors["Button".concat(type, "BackgroundPressed")] : !isToggled ? themeColors["Button".concat(type, "ToggleBackgroundOffPressed")] : themeColors["Button".concat(type, "ToggleBackgroundPressed")],
    // eslint-disable-next-line no-nested-ternary
    disabled: !isToggleable ? themeColors["Button".concat(type, "BackgroundDisabled")] : !isToggled ? themeColors["Button".concat(type, "ToggleBackgroundOffDisabled")] : themeColors["Button".concat(type, "ToggleBackgroundDisabled")],
    // eslint-disable-next-line no-nested-ternary
    border: !isToggleable ? 'transparent' : !isToggled ? themeColors["Button".concat(type, "ToggleBorderOff")] : themeColors["Button".concat(type, "ToggleBorderOn")],
    // eslint-disable-next-line no-nested-ternary
    borderHovered: !isToggleable ? 'transparent' : !isToggled ? themeColors["Button".concat(type, "ToggleBorderOffHovered")] : themeColors["Button".concat(type, "ToggleBorderOnHovered")],
    // eslint-disable-next-line no-nested-ternary
    borderPressed: !isToggleable ? 'transparent' : !isToggled ? themeColors["Button".concat(type, "ToggleBorderOffPressed")] : themeColors["Button".concat(type, "ToggleBorderOnPressed")],
    // eslint-disable-next-line no-nested-ternary
    borderDisabled: !isToggleable ? 'transparent' : !isToggled ? themeColors["Button".concat(type, "ToggleBorderOffDisabled")] : themeColors["Button".concat(type, "ToggleBorderOnDisabled")]
  };
};

var getColorSet = function getColorSet(props) {
  switch (props.kind) {
    case Types.FlatPrimary:
      return {
        hovered: props.themeColors.ButtonFlatPrimaryForegroundHovered,
        pressed: props.themeColors.ButtonFlatPrimaryForegroundPressed
      };

    case Types.FlatSecondary:
      return {
        hovered: props.themeColors.ButtonFlatSecondaryForegroundHovered,
        pressed: props.themeColors.ButtonFlatSecondaryForegroundPressed
      };

    case Types.Primary:
    case Types.PrimaryPill:
    case Types.Full:
    case Types.Secondary:
    case Types.SecondaryPill:
    case Types.Tertiary:
    case Types.TertiaryPill:
      return getFilledColorSet(props);

    case Types.Plain:
      return {
        default: props.isToggleable && !props.isToggled ? props.themeColors.ButtonPlainToggleBackgroundOff : props.themeColors.ButtonPlainBackground,
        hovered: props.isToggleable && !props.isToggled ? props.themeColors.ButtonPlainToggleBackgroundOffHovered : props.themeColors.ButtonPlainBackgroundHovered,
        pressed: props.isToggleable && !props.isToggled ? props.themeColors.ButtonPlainToggleBackgroundOffPressed : props.themeColors.ButtonPlainBackgroundPressed,
        disabled: props.isToggleable && !props.isToggled ? props.themeColors.ButtonPlainToggleBackgroundOffDisabled : props.themeColors.ButtonPlainBackgroundDisabled,
        border: 'transparent',
        borderHovered: 'transparent',
        borderPressed: 'transparent',
        borderDisabled: 'transparent'
      };

    default:
      throw Error("Unknown Button type provided: ".concat(props.kind));
  }
};

var getButtonStyle = function getButtonStyle(props) {
  var themedToggleBorderWidth = props.themeBorderWidth && props.themeBorderWidth["Button".concat(KIND_MAPPING[props.kind], "Toggle")];
  var buttonBorder = "".concat(props.isToggleable && themedToggleBorderWidth ? themedToggleBorderWidth : 1, "px");

  switch (props.kind) {
    case Types.FlatPrimary:
    case Types.FlatSecondary:
      return css(_templateObject2(), // prettier-ignore
      props.disabled && css(_templateObject3()), getFocusStyles(), getColorSet(props).hovered, getColorSet(props).pressed);

    case Types.Primary:
    case Types.PrimaryPill:
    case Types.Full:
    case Types.Secondary:
    case Types.SecondaryPill:
    case Types.Tertiary:
    case Types.TertiaryPill:
    case Types.Plain:
      {
        var border = "inset 0 0 0 1px ".concat(getColorSet(props).border);
        return css(_templateObject4(), props.isDepressed ? getColorSet(props).pressed : getColorSet(props).default, buttonBorder, getColorSet(props).border, props.isRaised ? ", ".concat(Shadows.Large) : '', getFocusStyles({
          boxShadows: props.isRaised ? [border, Shadows.Large] : [border]
        }), getColorSet(props).hovered, buttonBorder, getColorSet(props).borderHovered, props.isRaised ? ", ".concat(Shadows.Large) : '', getColorSet(props).pressed, buttonBorder, getColorSet(props).borderPressed, props.isRaised ? ", ".concat(Shadows.Large) : '', // prettier-ignore
        props.disabled && css(_templateObject5(), getColorSet(props).disabled, buttonBorder, getColorSet(props).borderDisabled, props.isRaised ? ", ".concat(Shadows.Large) : '', getColorSet(props).disabled, buttonBorder, getColorSet(props).borderDisabled, props.isRaised ? ", ".concat(Shadows.Large) : '', getColorSet(props).disabled, buttonBorder, getColorSet(props).borderDisabled, props.isRaised ? ", ".concat(Shadows.Large) : ''));
      }

    default:
      return null;
  }
};

export var ButtonRoot = withDynamicTag(styled.button(_templateObject6(), getPadding, getDisplay, function (props) {
  return props.padding !== Padding.None && css(_templateObject7(), getHeight(props));
}, getWidth, getJustifyContent, getBorderRadius, getDisabledStyle, getButtonStyle, function (props) {
  return props.isIconButton && css(_templateObject8(), props.squareSize, props.squareSize);
}));
export var TextOverflow = styled.div(_templateObject9());
export var SpinnerContainer = styled.div(_templateObject10());

var getOpacityForVisibility = function getOpacityForVisibility(props) {
  return props.isHidden ? 0 : 1;
};

export var ContentContainer = styled.div(_templateObject11(), getOpacityForVisibility);